// extracted by mini-css-extract-plugin
module.exports = {"container":"aboutme-module--container--3nHXJ","title":"aboutme-module--title--34rTZ","imageContainer":"aboutme-module--imageContainer--2jICM","text":"aboutme-module--text--120HK"};